import React from "react";
import {
  IStyleableComponentProps,
  ITestableComponent,
} from "../../shared-ui/common/component-props";
import styles from "./dot-icon.module.scss";
import clsx from "clsx";
import Tooltip from "../tooltip";

export enum DotIconColor {
  Red = "red",
  Green = "green",
  Yellow = "yellow",
  Gray = "gray",
}

export interface IDotIconProps
  extends IStyleableComponentProps,
    ITestableComponent {
  color: DotIconColor;
  tooltip: string;
  blink?: boolean;
}

export function DotIcon(props: IDotIconProps) {
  function icon() {
    return (
      <div
        className={clsx(
          props.className,
          styles.root,
          styles[`root--${props.color}`],
          props.blink && props.color === DotIconColor.Yellow && styles["root--blink"]
        )}
        style={props.style}
        data-testid={props.testId || `dot-icon-${props.color}`}
      ></div>
    );
  }

  if (props.tooltip) {
    return <Tooltip title={props.tooltip}>{icon()}</Tooltip>;
  } else {
    return icon();
  }
}
